import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "breadcrumbs flex-center" }
const _hoisted_2 = {
  key: 0,
  class: "arrow ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "breadcrumb flex-center mr-2",
        key: i
      }, [
        _createVNode(_component_router_link, {
          to: item.link,
          class: "underline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to"]),
        (i < (+(_ctx.items?.length || 0) - 1))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "→"))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}